import {
  MOBILE,
  FIXED,
  FIXEDOLO,
  INTERNATIONAL,
} from 'AppSrc/core/components/forms/value-dependency-constants';
import {
  COORDINATOR,
  REQUESTER,
} from 'AppSrc/core/components/forms/form-base-components/data-structure/constants';
import {
  CHANGE_TYPE,
  CHANGE_QUESTIONS,
  START_AND_END_DATE,
  CHANGE_DETAILS,
  WORK_INFORMATION_ITEMS,
  REFERENCES_SECTION,
  APPROVERS_SECTION,
  CHANGE_REQUEST_SUMMARY,
  RELATIONSHIPS,
  COMPLETION_REVIEW,
} from './section-constants';

// Single source of truth for the order of sections within create-crq,
const mobileSectionOrderDefault = [
  CHANGE_TYPE,
  CHANGE_QUESTIONS,
  START_AND_END_DATE,
  CHANGE_DETAILS,
  WORK_INFORMATION_ITEMS,
  CHANGE_REQUEST_SUMMARY,
  // COMPLETION_REVIEW,
];

const mobileSectionOrderCoordinator = [
  CHANGE_TYPE,
  CHANGE_QUESTIONS,
  START_AND_END_DATE,
  CHANGE_DETAILS,
  WORK_INFORMATION_ITEMS,
  RELATIONSHIPS,
  CHANGE_REQUEST_SUMMARY,
  // COMPLETION_REVIEW,
];

const fixedSectionOrderDefault = [
  CHANGE_TYPE,
  CHANGE_QUESTIONS,
  START_AND_END_DATE,
  CHANGE_DETAILS,
  REFERENCES_SECTION,
  WORK_INFORMATION_ITEMS,
  CHANGE_REQUEST_SUMMARY,
  // COMPLETION_REVIEW,
];

const fixedSectionOrderCoordinator = [
  CHANGE_TYPE,
  CHANGE_QUESTIONS,
  START_AND_END_DATE,
  CHANGE_DETAILS,
  REFERENCES_SECTION,
  WORK_INFORMATION_ITEMS,
  APPROVERS_SECTION,
  CHANGE_REQUEST_SUMMARY,
  // COMPLETION_REVIEW,
];

const fixedOloSectionOrder = [
  CHANGE_TYPE,
  CHANGE_QUESTIONS,
  START_AND_END_DATE,
  CHANGE_DETAILS,
  REFERENCES_SECTION,
  WORK_INFORMATION_ITEMS,
  CHANGE_REQUEST_SUMMARY,
];

const defaultSectionId = CHANGE_TYPE;
const sectionapproverSkip = CHANGE_REQUEST_SUMMARY;

const sectionOrderForNetwork = {
  // Mobile flow
  [MOBILE]: mobileSectionOrderDefault,
  [`${MOBILE}-${REQUESTER}`]: mobileSectionOrderDefault,
  [`${MOBILE}-${COORDINATOR}`]: mobileSectionOrderCoordinator,
  // Fixed flow
  [FIXED]: fixedSectionOrderDefault,
  [`${FIXED}-${REQUESTER}`]: fixedSectionOrderDefault,
  [`${FIXED}-${COORDINATOR}`]: fixedSectionOrderCoordinator,

  // FixedOlo flow
  [`${FIXED}-olo`]: fixedOloSectionOrder,
  [`${FIXED}-${REQUESTER}-olo`]: fixedOloSectionOrder,
  [`${FIXED}-${COORDINATOR}-olo`]: fixedOloSectionOrder,
};


const getCurrentSectionOrder = (params) => {
  const {
    network,
    userRoles,
    isOloCrq,
  } = params;

  // this will be undefined on section one so we don't warn for undefined
  const userRole = userRoles[network];

  let sectionKey = '';
  if (isOloCrq) {
    sectionKey = network ? `${network}-${userRole}-olo` : network;
  }
  else {
    sectionKey = network ? `${network}-${userRole}` : network;
  }

  return sectionOrderForNetwork[sectionKey];

};

// when parsing crq data we need to return all of the sections for a coordinator
// even if the user is a requester. This is because in viewCrq a requester can view
// all the data for their CRQ, even if they would not see the fields in the form
const getSectionOrderForParsingCrqData = (network, status) => {
  const sectionOrders = {
    [MOBILE]: mobileSectionOrderCoordinator,
    [FIXED]: fixedSectionOrderCoordinator,
    [FIXEDOLO]: fixedOloSectionOrder,
    [INTERNATIONAL]: fixedSectionOrderCoordinator,
  };
  const newsectionorder = sectionOrders[network];
  if (status === '7' || status === '10' || status === '11') {
    newsectionorder.push(COMPLETION_REVIEW);
  }
  return newsectionorder;
};


export {
  getCurrentSectionOrder,
  getSectionOrderForParsingCrqData,
  defaultSectionId,
  sectionapproverSkip,
};





